import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-ic-list-pilot",
  "use": "icon-ic-list-pilot-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"icon-ic-list-pilot\"><g fill-rule=\"nonzero\" fill=\"none\"><path fill=\"#ED593B\" d=\"M12 2c5.523 0 10 4.477 10 10s-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2zm0-2C5.373 0 0 5.373 0 12s5.373 12 12 12 12-5.373 12-12A12 12 0 0 0 12 0z\" /><path fill=\"#323337\" d=\"M8 6v12h4v-4h5V6H8zm6 7h-2V7h2v6z\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol